import React, { useEffect, useRef, useState } from 'react';

const DraggableList = (initialColumns: any) => {
  const [cols, setCols] = useState(initialColumns);
  const [dragOver, setDragOver] = useState<any | null>(null);
  const { list, headerName, dataTextField, dataValueField, onMoveUp, onMoveDown } = initialColumns;
  const [items, setItems] = useState<any>(list);
  const [selectedItemIndex, setSelectedItemIndex] = useState<number | null>(null);
  const [reportSummaryDataArray, setReportSummaryDataArray] = useState<any | ''>([]);
  const listRef = useRef<HTMLUListElement>(null);
  const scrollIntervalRef = useRef<NodeJS.Timeout | null>(null);
  const isDraggingRef = useRef(false);

  useEffect(() => {
    const handleAutoScroll = (e: DragEvent) => {
      if (!isDraggingRef.current || !listRef.current) return;

      const listElement = listRef.current;
      const rect = listElement.getBoundingClientRect();
      const scrollThreshold = 50;
      const scrollSpeed = 10;

      const mouseY = e.clientY;
      const distanceFromTop = mouseY - rect.top;
      const distanceFromBottom = rect.bottom - mouseY;
      if (scrollIntervalRef.current) {
        clearInterval(scrollIntervalRef.current);
        scrollIntervalRef.current = null;
      }

      if (distanceFromTop < scrollThreshold && distanceFromTop > 0) {
        scrollIntervalRef.current = setInterval(() => {
          if (listElement.scrollTop > 0) {
            listElement.scrollTop -= scrollSpeed;
          }
        }, 16);
      }

      else if (distanceFromBottom < scrollThreshold && distanceFromBottom > 0) {
        scrollIntervalRef.current = setInterval(() => {
          if (listElement.scrollTop < listElement.scrollHeight - listElement.clientHeight) {
            listElement.scrollTop += scrollSpeed;
          }
        }, 16);
      }
    };

    const stopAutoScroll = () => {
      if (scrollIntervalRef.current) {
        clearInterval(scrollIntervalRef.current);
        scrollIntervalRef.current = null;
      }
      isDraggingRef.current = false;
    };

    document.addEventListener('dragover', handleAutoScroll);
    document.addEventListener('dragend', stopAutoScroll);
    document.addEventListener('drop', stopAutoScroll);

    return () => {
      document.removeEventListener('dragover', handleAutoScroll);
      document.removeEventListener('dragend', stopAutoScroll);
      document.removeEventListener('drop', stopAutoScroll);
      if (scrollIntervalRef.current) {
        clearInterval(scrollIntervalRef.current);
      }
    };
  }, []);

  // Handle drag start
  const handleDragStart = (e: React.DragEvent<HTMLLIElement>, index: number) => {
    e.dataTransfer.setData('text/plain', index.toString());
    isDraggingRef.current = true;
  };

  // Prevent default behavior to allow dropping
  const handleDragOver = (e: React.DragEvent<HTMLLIElement>, index: any) => {
    e.preventDefault();
    setDragOver(index);
  };

  // Set column being dragged over
  const handleDragEnter = (e: React.DragEvent<HTMLLIElement>, index: any) => {
    e.preventDefault();
    setDragOver(e.currentTarget.dataset.index || null);
    setDragOver(index);
  };

  // Handle drop
  const handleOnDrop = (e: React.DragEvent<HTMLLIElement>, dropIndex: number) => {
    e.preventDefault();
    isDraggingRef.current = false;
    const draggedIndex = parseInt(e.dataTransfer.getData('text/plain'));
    if (!isNaN(draggedIndex) && draggedIndex !== dropIndex && items.length > 0) {
      const updatedItems = [...items];
      const [removed] = updatedItems.splice(draggedIndex, 1);
      updatedItems.splice(dropIndex, 0, removed);
      setItems(updatedItems);
      setDragOver(null);
      console.log('updatedItems:', updatedItems)
      if (draggedIndex < dropIndex) {
        onMoveUp(updatedItems)
      } else if (draggedIndex > dropIndex) {
        onMoveDown(updatedItems)
      }

      if (scrollIntervalRef.current) {
        clearInterval(scrollIntervalRef.current);
        scrollIntervalRef.current = null;
      }
    }

  };

  const handleItemClick = (index: number) => {
    setSelectedItemIndex(index);
  };


  return (
    <div className="custom-list-box">
      <ul className="draggable-list" ref={listRef}>
        <div className='order'>
          <h4>{headerName}</h4>
        </div>

        {items.map((item: any, index: any) => (
          // <li
          //   key={`${String(item[dataValueField])}-${index}`}

          //   data-index={index}
          //   draggable
          //   onDragStart={(e) => handleDragStart(e, index)}
          //   onDragOver={(e) => handleDragOver(e, index)}
          //   onDrop={(e) => handleOnDrop(e, index)}
          //   onDragEnter={(e) => handleDragEnter(e, index)}
          //   className={`draggable-list-item ${dragOver === index ? 'drag-over' : ''}`}

          // >
          //   {String(item[dataTextField])}
          // </li>
          <li
            key={`${String(item[dataValueField])}-${index}`}
            data-index={index}
            draggable
            onDragStart={(e) => handleDragStart(e, index)}
            onDragOver={(e) => handleDragOver(e, index)}
            onDrop={(e) => handleOnDrop(e, index)}
            onDragEnter={(e) => handleDragEnter(e, index)}
            className={`draggable-list-item ${dragOver === index ? 'drag-over' : ''}`}
          >
            <span className="drag-handle" onMouseDown={(e) => e.stopPropagation()}>≡


            </span>
            {String(item[dataTextField])}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DraggableList;